//
//
//
//
//
//
//

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    paddingTop:{
      type: String,
      default: '0px'
    }
  }, 
  data() {
    return {

    }
  }
}



// WEBPACK FOOTER //
// ./src/common/components/noData/index.vue